import React from 'react';
import { Link } from 'react-router-dom';
import MessageApprovalListUI from '../../../components/superUser/util/MessageApprovalListUI';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import GenericErrorUI from '../../../components/common/GenericErrorUI';
import MessageApprovalListNavUI from './MessageApprovalListNavUI';
import MessageCreateModalSF from '../../../components/superUser/util/MessageCreateModalSF';
import MessageUpdateModalSF from '../../../components/superUser/util/MessageUpdateModalSF';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';

const MessageApprovalListPageUI = ({ context, errorList, messageList,
    messageCreateMode, onCreateMessageClick, onCreateMessageCancel,
    onUpdateMessageClick, onUpdateMessageCancel, messageUpdateMode,
    onRefreshClick, account, selectedMessage,
    yearMonth, onPreviousClick, onNextClick
}) =>
    <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
        headerText={`${account ? account.accountName : ''}`} dimension='w768'
        centered={!account} account={account} page='messageApprovals'
    >
        {
            (!account || !errorList) &&
            <SpinnerComponentUI />
        }
        {messageList &&
            <LRTableActionsUI location='top'
                left={
                    <span className='g_flex_left g_flex_h'>
                        <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                        {/* <IconButtonUI icon='icon-plus' onClick={onCreateMessageClick} /> */}
                        <span className='g_m_left_100 g_large'><b>Message Approvals, {yearMonth.monthName} {yearMonth.year}</b></span>
                    </span>
                }
                right={
                    <span className='g_text_right'>
                        <div className='g_flex_h g_flex_right'>
                            <span className='g_m_left_100' />
                            <Link to='#' onClick={onPreviousClick}>Previous</Link>
                            <span className='g_m_left_100' />
                            <Link to='#' onClick={onNextClick}>Next</Link>
                        </div>
                    </span>
                }
            />
        }
        {messageList && messageList.length > 0 && (
            <div className="g_m_top_50">
                <b>Number of notices sent for loan:</b>
                <ol className="g_m_top_5">
                    {Object.entries(
                        messageList
                            .filter(msg => msg.loanReferenceNumber && msg.pendingStatus !== undefined)
                            .reduce((acc, msg) => {
                                // Grouping messages by loanReferenceNumber
                                if (!acc[msg.loanReferenceNumber]) {
                                    acc[msg.loanReferenceNumber] = [];
                                }
                                acc[msg.loanReferenceNumber].push(msg);
                                return acc;
                            }, {})
                    ).map(([loanReferenceNumber, messages]) => {
                        // Counting how many have 'pendingStatus' as null (i.e., notices sent)
                        const noticesSent = messages.filter(msg => msg.pendingStatus === null).length;

                        return (
                            <li key={loanReferenceNumber}>
                                <Link to={`/su/loans/${messages[0].loanId}`}>{loanReferenceNumber}</Link>
                                <span>
                                    {noticesSent > 0
                                        ? ` - (${noticesSent} notice${noticesSent > 1 ? 's' : ''} sent)`
                                        : ' - (No notices sent)'}
                                </span>
                            </li>
                        );
                    })}
                </ol>
            </div>
        )}
            <MessageApprovalListNavUI
                context={context}
                page='messageApprovals'
                account={account}
            />

        {
            messageList && messageList.length > 0 &&
            <MessageApprovalListUI
                context={context}
                onUpdateMessageClick={onUpdateMessageClick}
                messages={messageList}
            />
        }
        {
            messageList && messageList.length === 0 &&
            <EmptyListUI
                context={context}
                createDisabledMessageLabel='No Message Approvals'
            />
        }

        <MessageCreateModalSF context={context} account={account}
            messageCreateMode={messageCreateMode}
            onCreateMessageCancel={onCreateMessageCancel} onRefreshClick={onRefreshClick}
        />

        <MessageUpdateModalSF context={context}
            message={selectedMessage} messageUpdateMode={messageUpdateMode}
            onUpdateMessageCancel={onUpdateMessageCancel} onRefreshClick={onRefreshClick}
        />
    </SuperUserAccountPageUI >


export default MessageApprovalListPageUI;
